import AdminSlotActivity from "@/components/tpr/AdminSlotActivity/AdminSlotActivity";
import BillingSummary from "@/components/tpr/BillingSummary/BillingSummary";
import Heading from "@/components/tpr/Heading/Heading";
import LocationsGrid from "@/components/tpr/LocationsGrid/LocationsGrid";
import SimpleBookingsList from "@/components/tpr/SimpleBookingsList/SimpleBookingsList";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Item, ItemContent, ItemDescription, ItemMedia, ItemTitle } from "@/components/ui/item";
import { useMember } from "@/contexts/memberContext";
import { getInitials } from "@/lib/utils";
import { BookOpen, ExternalLink } from "lucide-react";

const MEMBERS_MANUAL_URL =
  "https://docs.google.com/document/d/1FHqeKMoc8hzeH8h_-SeHVtiPYGBTd5hm/edit?usp=drive_link&ouid=105280744071070146731&rtpof=true&sd=true";

const Dashboard = () => {
  const { member, todaysBookings } = useMember();
  const fullName = member ? `${member.firstName} ${member.lastName}` : "User";
  const initials = getInitials(fullName);

  return (
    <div>
      <div className="relative">
        <div className="relative pt-4 px-4 min-h-screen">
          <div className="mb-4">
            <Item variant="outline" className="bg-gradient-to-r from-blue-500 to-blue-700">
              <ItemContent>
                <div className="flex flex-row">
                  <div className="mr-4 relative hidden md:block">
                    <Avatar className="w-16 h-16">
                      <AvatarImage
                        src={
                          member?.avatar ||
                          "https://images.unsplash.com/photo-1668580112791-2a453788ed9e?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=256"
                        }
                        alt={fullName || "User Avatar"}
                      />
                      <AvatarFallback>{initials}</AvatarFallback>
                    </Avatar>
                  </div>
                  <div className="flex flex-col md:pt-2.5">
                    <ItemTitle className="block text-base md:text-1xl text-white font-semibold">
                      Welcome back, {member?.firstName || ""}!
                    </ItemTitle>
                    <ItemDescription className="text-white">
                      You have <span>{todaysBookings}</span> bookings today.
                    </ItemDescription>
                  </div>
                </div>
              </ItemContent>
            </Item>
          </div>

          <div className="mb-4">
            <a
              href={MEMBERS_MANUAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="block group"
            >
              <Item
                variant="outline"
                className="bg-gradient-to-r from-blue-50 to-white dark:from-gray-800 dark:to-gray-900 transition-colors group-hover:border-blue-500"
              >
                <ItemMedia>
                  <BookOpen className="w-5 h-5 text-blue-600" />
                </ItemMedia>
                <ItemContent>
                  <ItemTitle className="text-sm font-semibold">
                    Member's Manual - Hearth Booking System
                  </ItemTitle>
                  <ItemDescription>Opens in a new window</ItemDescription>
                </ItemContent>
                <ExternalLink className="w-4 h-4 text-gray-400 self-center" />
              </Item>
            </a>
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-8">
            <div>
              <div className="mb-8 mt-8">
                <Heading title="Your locations" />
              </div>
              <LocationsGrid />
            </div>

            <div>
              {/* Admin-only slot activity — renders null for members/PMs (self-gated). */}
              <AdminSlotActivity />

              <div className="mb-8 mt-8">
                <Heading title="Your bookings" />
              </div>
              <SimpleBookingsList />
              <BillingSummary />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
